// src/components/RedeemPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../i18n/I18nContext';
import { getMiscPageCopy } from '../i18n/miscPageCopy';
import '../style/Homepage.css';
import '../style/Redeem.css';

const RedeemPage = () => {
  const { language } = useI18n();
  const copy = getMiscPageCopy(language).redeem;

  return (
  <div>
    <Header />
    <main className="info-page redeem-page">
      <section className="redeem-hero-card">
        <div>
          <p className="eyebrow">{copy.eyebrow}</p>
          <h1>{copy.title}</h1>
          <p>{copy.description}</p>
          <div className="hero-actions">
            <Link to="/login" className="primary-button">{copy.primary}</Link>
            <Link to="/contact?topic=payment" className="secondary-button">{copy.secondary}</Link>
          </div>
        </div>
        <div className="redeem-app-card" aria-label={copy.location}>
          <span>{copy.location}</span>
          <strong>{copy.account}</strong>
          <p>{copy.locationBody}</p>
          <Link to="/register" className="secondary-button">{copy.create}</Link>
        </div>
      </section>

      <section className="redeem-steps-grid" aria-label={copy.stepsLabel}>
        {copy.steps.map(([title, body], index) => (
          <article className="redeem-step-card" key={title}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <h2>{title}</h2>
            <p>{body}</p>
          </article>
        ))}
      </section>

      <section className="redeem-types-section">
        <div className="section-heading">
          <p className="eyebrow">{copy.typesEyebrow}</p>
          <h2>{copy.typesTitle}</h2>
        </div>
        <div className="redeem-types-grid">
          {copy.types.map(([title, body]) => (
            <article className="redeem-type-card" key={title}>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="terms-notice redeem-notice">
        <div>
          <p className="eyebrow">{copy.noticeEyebrow}</p>
          <h2>{copy.noticeTitle}</h2>
        </div>
        <p>{copy.noticeBody}</p>
      </section>

      <section className="redeem-help-section">
        <div className="section-heading">
          <p className="eyebrow">{copy.failEyebrow}</p>
          <h2>{copy.failTitle}</h2>
        </div>
        <ul className="redeem-checklist">
          {copy.checks.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="terms-contact-card redeem-contact-card">
        <div>
          <p className="eyebrow">{copy.helpEyebrow}</p>
          <h2>{copy.helpTitle}</h2>
        </div>
        <p>{copy.helpBody} <Link to="/contact?topic=payment">{copy.contactPage}</Link>. <Link to="/gift">{copy.gift}</Link>.</p>
      </section>
    </main>
    <Footer />
  </div>
  );
};

export default RedeemPage;
